"use client";

import "@/app/globals.css";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Stack } from "@/components/ui/stack";
import { Typography } from "@/components/ui/typography";

import { reportErrorToRollbar } from "@/lib/rollbar/client";

export default function GlobalErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportErrorToRollbar(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased">
        <div className="flex h-full items-center justify-center">
          <div className="my-8 p-4">
            <Stack gap={4}>
              <Heading variant="section">
                Oops! We've encountered an error.
              </Heading>
              <Typography>Please try again in a moment.</Typography>
              <Button onClick={() => reset()}>Try again</Button>
            </Stack>
          </div>
        </div>
      </body>
    </html>
  );
}
